import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { formatMessage } from '../../../translations/format-message';
import './calendar-view.css';

type ValuePiece = Date | null;
type Value = ValuePiece | [ValuePiece, ValuePiece];

interface IProps {
  selectedYear: number;
  holidays: any[];
  weekends: number[];
  setSelectedDate: (date: Date) => void;
  deleteHandler: (holidayId: number, holidayYear: number) => void;
  language?: string;
}
const CalendarView = (props: IProps) => {
  const highlightHolidays = ({ date, view }) => {
    if (view === 'month') {
      const formattedDate = new Date(
        date.getTime() - date.getTimezoneOffset() * 60000
      ) // Adjust for local timezone
        .toISOString()
        .split('T')[0];
      if (props.holidays[formattedDate]) {
        return (
          <div
            onClick={(e) => {
              if (props.selectedYear >= new Date().getFullYear()) {
                //Handle delete popup here....
                props.deleteHandler(
                  props.holidays[formattedDate].holidayId,
                  props.selectedYear
                );
              }
              e.stopPropagation();
            }}
            className="holiday-list"
            title={props.holidays[formattedDate].label}
            style={{
              backgroundColor: props.holidays[formattedDate].color,
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor:
                props.selectedYear < new Date().getFullYear()
                  ? 'not-allowed'
                  : 'pointer',
            }}
          >
            {date.getDate()}
          </div>
        );
      }
    }
    return null;
  };

  const tileClassName = ({ date, view }: { date: Date; view: string }) => {
    const tileClassArr = [];
    const day = date.getDay();
    if (day === props.weekends[0] || day === props.weekends[1]) {
      tileClassArr.push('custom-weekend');
    }

    if (view === 'month') {
      const formattedDate = date.toISOString().split('T')[0];
      if (props.holidays[formattedDate]) {
        tileClassArr.push('holiday-apply'); // Custom class for hiding the default number
      }
    }
    return tileClassArr;
  };

  const renderAllMonths = () => {
    return Array.from({ length: 12 }).map((_, index) => {
      const monthStartDate = new Date(props.selectedYear, index, 1);
      return (
        <div
          className="col-md-3 col-lg-4 mb-4"
          key={index}
        >
          <div className="p-2 border rounded shadow-sm calender-year">
            <h3 className="text-center">
              {monthStartDate.toLocaleString(
                props.language === 'jp' ? 'ja-JP' : 'default',
                { month: 'long' }
              )}
            </h3>
            <Calendar
              value={monthStartDate}
              tileContent={highlightHolidays}
              defaultView="month"
              showNavigation={false}
              showNeighboringMonth={false}
              tileClassName={tileClassName}
              calendarType="gregory"
              locale={props.language === 'jp' ? 'ja-JP' : 'en-US'}
              onClickDay={handleDateClick}
              formatDay={(_, date) => {
                return String(date.getDate());
              }}
            />
          </div>
        </div>
      );
    });
  };

  const handleDateClick = (value: Date) => {
    const correctedDate = new Date(
      props.selectedYear,
      value.getMonth(),
      value.getDate()
    );
    props.setSelectedDate(correctedDate);
  };

  return (
    <div className="calendarView_height px-3 my-4">
      <h1 className="text-center mb-4">
        {formatMessage('calendar_for')} {props.selectedYear}
      </h1>
      <div className="row">{renderAllMonths()}</div>
    </div>
  );
};

export default CalendarView;
